module.exports = __webpack_public_path__ + "static/trace-error-ad7256a89d1f32cba67286f4da3ad620.png";